import styled from 'styled-components';
import colors from '../../../assets/colors';

const Container = styled.div`
  min-width: 200px;
  position: absolute;
  top: 40px;
  z-index: 9999;
  background: #FFF;
  border-radius: 8px;
  border: 1px solid #DDDDDD;

  .tab-item {
    padding: 5px 0;
    margin: 0;
    list-style: none;
    
    li {
      padding: 10px 15px;
      font-size: 0.9rem;
      border-bottom: 1px solid #EAEAEA;
      cursor: pointer;

      :hover { background-color: #F9F9F9; }
      :last-child { border: none; }
    }

    li.selected {
      background-color: ${colors.primary};
      color: #FFF;
    }
  }

  @media screen and (max-width: 430px) {
    width: 100%;
  }

  @media screen and (min-width: 1179px) {
    display: none;
  }
`;

export default Container;
